import { CustomerTableHeader } from '../TableHeader/TableHeader';
import '../Table.scss';
import { useNavigate } from 'react-router-dom';
import UserIcon from '../../../assets/icons/user-icon.svg';
import ProfilePic from '../../../assets/images/Profilepicture.webp';
import { getMMDDYY } from '../../../helpers/utils/date';

const CustomersTableBody = ({ tableData, isCustomers, basePath }: any) => {
  const navigate = useNavigate();

  return (
    <>
      <div className={`table-container general-table ${isCustomers ? 'is-customers' : ''}`}>
        <table className="table">
          <CustomerTableHeader />
          <tbody className="table-body">
            {tableData &&
              tableData.map((val: any, index: any) => {
                const targetPath = basePath ? `${basePath}${val.userId}` : `/customer/${val.userId}`;
                return (
                  <tr
                    key={index}
                    id={val.userId}
                    className="table-row"
                    onClick={() => {
                      navigate(targetPath);
                    }}
                  >
                    <td className="cust-name">
                      <div className="user-icon">
                        <img
                          src={
                            val.userPic ? `${process.env.REACT_APP_USER_AVATAR_THUMB_BASE}${val.userPic}` : ProfilePic
                          }
                          alt={UserIcon}
                        />
                        <td>{`${val.firstName} ${val.lastName}`}</td>
                      </div>
                    </td>
                    <td className="email">{val.email}</td>
                    <td className="">{val.phone}</td>
                    <td className="cust-user-id">{val.userId}</td>
                    <td>{getMMDDYY(val.joined, `MMM YYYY`)}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export { CustomersTableBody };
